import { createStore } from "vuex";

export default createStore({
  state: {
    crumbs: '',
    dtType: 'YY',
    targetId: '',
  },
  mutations: {
    setCrumbs(state, val) {
      state.crumbs = val
    },
    setDtType(state, val) {
      if (val) {
        let text = val.split(',').join('').substr(-2, 2)
        state.dtType = text
      }
    },
    setTargetId(state, val) {
      state.targetId = val
    }
  },
  actions: {
    aSetCrumbs(context, val) {
      context.commit('setCrumbs', val)
    },
    aSetDtType(context, val) {
      context.commit('setDtType', val)
    },
    aSetTargetId(context, val) {
      context.commit('setTargetId', val)
    }
  }
})